export default __webpack_public_path__ + "static/media/Green0004.07032e16.png";